module.exports = __webpack_public_path__ + "@/assets/img/010-girl-4.65eb3fa2.svg";